"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = chatReducer;
var _ChatActions = require("./ChatActions");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  chat: [],
  chatPagination: {
    page: null,
    perPage: null,
    count: null
  },
  contacts: [],
  currentMail: '',
  getChatInProgress: false,
  getContactsInProgress: false,
  isOpenChatPanel: false,
  labels: [],
  mobileChatsSidebarOpen: false,
  selectedContactId: null,
  sendMessageInProgress: false
};
function chatReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _ChatActions.CLEAN_CHAT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          chat: [],
          chatPagination: null
        });
      }
    case _ChatActions.GET_CHAT_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        getChatInProgress: true
      });
    case _ChatActions.GET_CHAT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        chat: [].concat(_toConsumableArray(action.chat), _toConsumableArray(state.chat)),
        chatPagination: action.pagination,
        getChatInProgress: false
      });
    case _ChatActions.GET_CHAT_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        getChatInProgress: false
      });
    case _ChatActions.REMOVE_CHAT:
      return _objectSpread(_objectSpread({}, state), {}, {
        chat: null
      });
    case _ChatActions.SEND_MESSAGE_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        sendMessageInProgress: true
      });
    case _ChatActions.SEND_MESSAGE_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        chat: [].concat(_toConsumableArray(state.chat), [action.message]),
        // todo : set message error
        sendMessageInProgress: false
      });
    case _ChatActions.SEND_MESSAGE_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        // todo: message with error
        sendMessageInProgress: false
      });
    case _ChatActions.ADD_MESSAGE_OF_PROPOSITION:
      return _objectSpread(_objectSpread({}, state), {}, {
        chat: [].concat(_toConsumableArray(state.chat), _toConsumableArray(action.message))
      });
    case _ChatActions.GET_CONTACTS_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        getContactsInProgress: true
      });
    case _ChatActions.GET_CONTACTS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        contacts: _toConsumableArray(action.contacts),
        getContactsInProgress: false
      });
    case _ChatActions.GET_CONTACTS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        getContactsInProgress: false
      });
    case _ChatActions.GET_CONTACT_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        getContactsInProgress: true
      });
    case _ChatActions.GET_CONTACT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        contacts: [action.contacts],
        getContactsInProgress: false
      });
    case _ChatActions.GET_CONTACT_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        getContactsInProgress: false
      });
    case _ChatActions.SET_SELECTED_CONTACT_ID:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedContactId: action.contactId
      });
    case _ChatActions.REMOVE_SELECTED_CONTACT_ID:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedContactId: null
      });
    case _ChatActions.OPEN_CHAT_PANEL:
      return _objectSpread(_objectSpread({}, state), {}, {
        isOpenChatPanel: true
      });
    case _ChatActions.CLOSE_CHAT_PANEL:
      return _objectSpread(_objectSpread({}, state), {}, {
        chat: [],
        isOpenChatPanel: false,
        selectedContactId: null
      });
    case _ChatActions.TOGGLE_CHAT_PANEL:
      return _objectSpread(_objectSpread({}, state), {}, {
        isOpenChatPanel: !state.isOpenChatPanel
      });
    case _ChatActions.OPEN_MOBILE_CHATS_SIDEBAR:
      return _objectSpread(_objectSpread({}, state), {}, {
        mobileChatsSidebarOpen: true
      });
    case _ChatActions.CLOSE_MOBILE_CHATS_SIDEBAR:
      return _objectSpread(_objectSpread({}, state), {}, {
        mobileChatsSidebarOpen: false
      });
    case _ChatActions.CREATE_CONVERSATION_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        createConversationInprogress: true,
        conversation: null
      });
    case _ChatActions.CREATE_CONVERSATION_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        createConversationInprogress: false,
        conversation: action.payload
      });
    case _ChatActions.CREATE_CONVERSATION_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        createConversationInprogress: false
      });
    default:
      return state;
  }
}